/** Flatten a message object into human-readable `"key.path: value"` lines. */
export function getMessageContent(obj: any, prefix = '', result: string[] = []) {
  for (const [key, value] of Object.entries(obj)) {
    const newKey = prefix ? `${prefix}.${key}` : key;

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      getMessageContent(value, newKey, result);
    } else if (Array.isArray(value)) {
      if (value.length === 0) {
        result.push(`${newKey}: []`);
      } else {
        value.forEach((item, index) => {
          if (item && typeof item === 'object') {
            getMessageContent(item, `${newKey}.${index}`, result);
          } else {
            result.push(`${newKey}.${index}: ${item}`);
          }
        });
      }
    } else {
      result.push(
        `${newKey}: ${value === null ? 'null' : value === undefined ? 'undefined' : typeof value === 'string' ? `"${value}"` : value}`,
      );
    }
  }
  return result;
}

/** Collect every `name` in a signature-requirement key tree (depth-first through `keys`). */
export function getKeyNames(obj: any, names: string[] = []) {
  if (!obj) throw new Error('Missing required obj to get key names for the job entity');

  if (typeof obj === 'object' && obj !== null) {
    if (obj['name']) {
      names.push(obj.name);
    }

    if (Array.isArray(obj.keys)) {
      for (const item of obj.keys) {
        getKeyNames(item, names);
      }
    }
  }

  return names;
}

/** Find the node with the given `name` in a signature-requirement key tree, or null. */
export function getKeyValue(obj: any, targetName: string): any {
  if (typeof obj === 'object' && obj !== null) {
    if (obj.name && obj.name === targetName) {
      return obj;
    }

    if (Array.isArray(obj.keys)) {
      for (const item of obj.keys) {
        const found = getKeyValue(item, targetName);
        if (found) {
          return found;
        }
      }
    }
  }
  return null;
}

export function hasSameSignatories(current: string[], proposed: string[]) {
  const currentIds = new Set(current);
  const proposedIds = new Set(proposed);
  return currentIds.size === proposedIds.size && [...proposedIds].every((id) => currentIds.has(id));
}
